<template>
  <ContainerSeller>
    <template #default="{ productResponse, selectedOffer }">
      <Seller
        v-if="productResponse && selectedOffer && selectedOffer.merchant"
        :company="selectedOffer.merchant.company"
        :merchant-id="selectedOffer.merchant.merchantId"
        :merchant-url="selectedOffer.merchant.merchantUrl"
      />
    </template>
  </ContainerSeller>
</template>

<script setup lang="ts">
import ContainerSeller from '~/scopes/product-core/components/ContainerSeller/ContainerSeller.vue'

import Seller from './components/Seller/Seller.vue'
</script>
